import {
  CommonModule,
} from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import {
  statusClassWithCondition,
  TableColumn,
} from "src/app/services/models/tables.model";
import { KeeniconComponent } from "../../keenicon/keenicon.component";
import { ProgressLoadingComponent } from "../../progress-loading/progress-loading.component";
import { PaginationsComponent } from "../course-table/paginations/paginations/paginations.component";

@Component({
  selector: "app-table-widget",
  templateUrl: "./table-widget.component.html",
  styleUrl: "./table-widget.component.scss",
  imports: [
    CommonModule,
    TranslateModule,
    KeeniconComponent,
    ProgressLoadingComponent,
    PaginationsComponent,
  ],
})
export class TableWidgetComponent implements OnInit {
  @Input() showCardHeader = false;
  @Input() tableLabel = "APP.ITEMS";
  @Input() buttonLabel = "APP.ADD";
  @Input() containerClass = "h-table-custom";
  @Input() showCardSpace = true;
  @Input() showHoverBg = true;
  @Input() rowClick = true;
  @Input() rowBorderBottom = true;
  @Input() scrollToTop = false;

  @Input() dataTable = false;
  @Input() dataColumns: TableColumn[] = [];

  @Output() rowSelected = new EventEmitter();
  @Output() buttonClick = new EventEmitter();
  @Output() tableChange = new EventEmitter();

  loading = true;
  sources: any;

  vertical_scrollbar = false;

  @Input()
  set dataSource(value: any) {
    if (value !== null && value !== undefined) {
      this.sources = value;
    }
  }

  @Input() set isLoading(value: boolean) {
    this.loading = value;

    if (!this.loading && this.scrollToTop) {
      const element = document.getElementById("table_header");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" }); // scroll smoothly to the element
      }
    }
  }

  ngOnInit(): void {
    const table = document.getElementById("widget-table") as HTMLElement;

    if (!this.rowClick) {
      this.showHoverBg = false;
    }
  }

  objectKeyValue(prop: string | undefined) {
    return prop as string;
  }

  statusIndex(index: number, value: any) {
    const column = this.dataColumns[index];
    if (this.isArray(column.statuses)) {
      const index =
        column.statuses.findIndex(
          (status_id: number) => status_id === value,
        ) || 0;
      return index;
    } else {
      return 0;
    }
  }

  mapConditionClass(
    value: string | number | boolean,
    statusArray: statusClassWithCondition[],
  ): statusClassWithCondition | undefined {
    return statusArray.find(
      (i: statusClassWithCondition) => i.id === value || i.name === value,
    );
  }
  clickedRow(data: any) {
    this.rowSelected.emit(data);
  }

  isArray(key: any) {
    return Array.isArray(key);
  }

  onTableChange(event: Event) {
    this.tableChange.emit(event);
  }
  onClick() {
    this.buttonClick.emit(true);
  }
}
